import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import upperFirst from 'lodash/upperFirst';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import get from 'lodash/get';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import Stepper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Stepper';
import ToolbarList from '@configuratorware/configurator-frontendgui/App/Shared/Components/ToolbarList';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(
    theme => ({
        root: {
            flexGrow: 1,
        },
        grow: {
            flexGrow: 1,
        },
        HeaderComponentRoot: {
            overflow: 'hidden',
        },
        toolbarHeaderComponentWrapper: {
            minHeight: 64,
            padding: '0 20px',
            [theme.breakpoints.down('xs')]: {
                padding: '0 0 0 20px',
            },
        },
        hiddenEmailShareIframe: {
            visibility: 'hidden',
            position: 'absolute',
        },
        itemIdentifierLabel: {
            fontSize: 15,
            [theme.breakpoints.down('sm')]: {
                fontSize: 12,
            },
        },
        formControl: {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(1),
          marginRight: theme.spacing(3),
          minWidth: 150,
          maxWidth: 500,
          [theme.breakpoints.down('xs')]: {
              marginRight: theme.spacing(1),
              '& .MuiInput-root': {
                  maxWidth: 144,
              },
          },
      },
        itemIdentifier: {
            fontWeight: 'bold',
            fontSize: 15,
            marginLeft: theme.spacing(1),
            [theme.breakpoints.down('sm')]: {
                fontSize: 12,
            },
        },
        itemIdentifierContainer: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'flex',
            flexDirection: 'row',
            marginLeft: theme.spacing(2),
            [theme.breakpoints.down('xs')]: {
                display: 'none',
            },
        },
        typographyBody: {
          fontWeight: 'bold',
          fontSize: 15,
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          marginRight: 5,
          lineHeight: '18px',
          textAlign: 'center',
          letterSpacing: 'unset',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          [theme.breakpoints.down('sm')]: {
              fontSize: 12,
          },
        },
      }),
    {
        name: 'HeaderComponent',
    }
);

const HeaderComponent = props => {
    const classes = useStyles(props);
    const {
        tools,
        steps,
        variants,
        selectedVariantIdentifier,
        title,
        selectedVariant,
        showItemIdentifier,
    } = props;

    return (
        <div className={classes.root}>
            <AppBar
                position="static"
                color="default"
                className={clsx(classes.HeaderComponentRoot, customClassName('HeaderComponent'))}
            >
                <Toolbar classes={{ regular: classes.toolbarHeaderComponentWrapper }}>
                  {variants.length > 0 && selectedVariant && <div className={classes.formControl}>
                    <Typography
                        component="div"
                        className={classes.itemIdentifier}
                        variant="body2"
                    >
                        {upperFirst(get(variants.find(v => v.value === selectedVariant), 'title', ''))}
                    </Typography>
                  </div>}
                  <Typography classes={{ body2: classes.typographyBody }} component="p" variant="body2">
                        {title}
                  </Typography>
                    {showItemIdentifier && (
                        <div className={classes.itemIdentifierContainer}>
                            <Typography
                                component="div"
                                className={classes.itemIdentifierLabel}
                                variant="body2"
                            >
                                {t('HeaderComponentMenu.item_identifier_label') !== 'HeaderComponentMenu.item_identifier_label'
                                    ? t('HeaderComponentMenu.item_identifier_label')
                                    : ''}
                            </Typography>
                            <Typography component="div" className={classes.itemIdentifier} variant="body2">
                                {selectedVariantIdentifier}
                            </Typography>
                        </div>
                    )}
                    <div className={classes.grow}>{steps && <Stepper tabs={steps} />}</div>
                    <ToolbarList tools={tools} />
                </Toolbar>
            </AppBar>
        </div>
    );
};

HeaderComponent.propTypes = {
    tools: PropTypes.array,
    steps: PropTypes.array,
    variants: PropTypes.array,
    selectedVariant: PropTypes.string,
    selectedVariantIdentifier: PropTypes.string,
    title: PropTypes.string,
    switchSelectedAmount: PropTypes.func,
    VariantChooserComponent: PropTypes.elementType,
    showItemIdentifier: PropTypes.bool,
};

HeaderComponent.defaultProps = {
    variants: [],
};

export default HeaderComponent;
